// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-control-custom {
  padding: 0.8rem 0.75rem !important;
}

.form-select-custom {
  padding: 0.8rem 2.25rem 0.8rem 0.75rem !important;
}

.btn-primary:hover {
  color: blue;
}

.bg-black {
  background-color: black;
}

.btn-primary:hover {
  background-color: chocolate;
  color: white;
}

.cancel-button {
  position: absolute;
  top: 1rem;
  right: 1rem;
  color: #f5f5f5;
  background-color: tomato;
  border-radius: 50%;
  cursor: pointer;
  text-align: center;
  width: 22px;
  height: 22px;
}
`, "",{"version":3,"sources":["webpack://./src/assets/style.css"],"names":[],"mappings":"AAAA;EACE,kCAAkC;AACpC;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,cAAc;EACd,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd","sourcesContent":[".form-control-custom {\n  padding: 0.8rem 0.75rem !important;\n}\n\n.form-select-custom {\n  padding: 0.8rem 2.25rem 0.8rem 0.75rem !important;\n}\n\n.btn-primary:hover {\n  color: blue;\n}\n\n.bg-black {\n  background-color: black;\n}\n\n.btn-primary:hover {\n  background-color: chocolate;\n  color: white;\n}\n\n.cancel-button {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n  color: #f5f5f5;\n  background-color: tomato;\n  border-radius: 50%;\n  cursor: pointer;\n  text-align: center;\n  width: 22px;\n  height: 22px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
